
import {Component, Vue, Watch} from "vue-property-decorator";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import BorcluForm from "@/components/forms/BorcluForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import AlacakList from "@/components/lists/AlacakList.vue";
import TakipAlacakliPicker from "@/components/pickers/TakipAlacakliPicker.vue";
import DokumanList from "@/components/lists/DokumanList.vue";
import {TakipEntity} from "@/entity/TakipEntity";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import {ProgramPaths} from "@/enum/ProgramPaths";
import NotForm from "@/components/forms/NotForm.vue";
import TopluNotClass from "@/classes/TopluNotClass";

@Component({
  components: {NotForm, DokumanList, TakipAlacakliPicker, AlacakList, FormWrapper, BorcluForm, FormDialog, ProgramPaths}
})
export default class TopluNotAlma extends Vue {

  bitis: any;
  baslangic: any;
  takip: TakipEntity | null = null;
  araliktakiTakipler = [];
  parser: any;
  xmlDoc: any = [];
  xml = "";
  stepler = [];
  secimler: boolean = false;
  indirmeyeDevamEt: boolean = false;

  xmlObject = [{
    kart_no: "",
    messages: "",
    status: false,
    color: ""
  }];

  headers = [
    {text: "Kart No", value: "kart_no",align:'start', class: 'my-header-style'},
    {text: "Durum", value: "messages", class: 'my-header-style'},
    {text: "Karta Git", value: "actions",align:'end', class: 'header-actions-style'},
  ];


  icraDairesi: boolean = false;

  secilenler = [];
  e1 = 1;

  basariliMi: boolean[] = []
  indirilecekXmller: any = []
  ready = false;


  hataMesajlari: any = [];
  xmlUyari: boolean = false;
  kontrol: boolean = false;
  eksikVarMi: boolean = false;
  takipNasilAcilacak: string = "online";
  notBilgileri: {
    not_tur_id: number;
    takip_id: any;
    not: string | null;
  } = {
    not_tur_id: 0,
    takip_id: [],
    not: null,
  };

  @Watch('secilenler')
  changeSecilenler(notlar:any){
    this.notBilgileri = {
      not_tur_id:notlar.not_tur_id,
      takip_id:this.secilenler,
      not: notlar.not
    }
  }

  handleNot(notlar:any){
    this.notBilgileri = {
      not_tur_id:notlar.not_tur_id,
      takip_id:this.secilenler,
      not: notlar.not
    }
  }

  @Watch('secimler')
  stepleriTemizle() {
    this.xmlObject = [];
  }
  onlyAllowNumbers(event:any) {
    if ((event.key < '0' || event.key > '9') && event.key !== 'Backspace' && event.key !== 'Enter') {
      event.preventDefault();
    }
  }
  async belirlenenAraliktakiTakipleriKontrolEt() {
    this.stepleriTemizle();
    this.kontrol = true;
    this.basariliMi = [];
    this.indirilecekXmller = [];
    this.secilenler = [];
    this.indirmeyeDevamEt = false;
    this.xmlObject = [];

    const baslangic = Number(this.baslangic);
    const bitis = Number(this.bitis);

    if (isNaN(baslangic) || isNaN(bitis) || baslangic > bitis) {
      this.kontrol = false;
      this.$toast.error("Geçersiz aralık! Lütfen başlangıç ve bitiş değerlerini kontrol edin.");
      return;
    }

    const takipNolari = [];
    for (let i = baslangic; i <= bitis; i++) {
      takipNolari.push(i.toString());
    }

    const payload = {
      ...this.notBilgileri,
      takip_id: takipNolari
    };

    try {
      StatusCodeHelper.dontShow404Alert = true;
      const response = await this.$http.post('/api/v1/toplu-not-ekle', payload);

      if (response.data.status) {
        this.xmlObject = takipNolari.map(kartNo => ({
          kart_no: kartNo,
          messages: "Not başarıyla eklendi",
          status: false,
          color: "#0ce11d"
        }));
      } else {
        const invalidIds = response.data.gecersiz_idler || [];

        this.xmlObject = takipNolari.map(kartNo => {
          if (invalidIds.includes(kartNo)) {
            return {
              kart_no: kartNo,
              messages: "Takip bulunamadı",
              status: true,
              color: "#FFEBEE"
            };
          } else {
            return {
              kart_no: kartNo,
              messages: "Not başarıyla eklendi",
              status: false,
              color: "#0ce11d"
            };
          }
        });

        this.eksikVarMi = invalidIds.length > 0;
      }
    } catch (err) {
      console.error('Error in belirlenenAraliktakiTakipleriKontrolEt:', err);

      this.xmlObject = takipNolari.map(kartNo => ({
        kart_no: kartNo,
        messages: err.response?.data?.message || "Not eklenirken hata oluştu",
        status: true,
        color: "#FFEBEE"
      }));

      if (err.response?.data?.gecersiz_idler) {
        this.eksikVarMi = err.response.data.gecersiz_idler.length > 0;
      }
    } finally {
      StatusCodeHelper.dontShow404Alert = false;
      this.kontrol = false;
      this.ready = true;
    }
  }

  kartaGit(kartNo:any){
    this.$router.push(ProgramPaths.icrapro + "/takip-ekle/" + kartNo);
  }


  async SecilenTakipleriTakipleriKontrolEt() {
    this.stepleriTemizle();
    this.kontrol = true;
    this.basariliMi = [];
    this.baslangic = null;
    this.indirmeyeDevamEt = false;
    this.bitis = null;
    this.indirilecekXmller = [];
    this.xmlObject = []; // Clear previous results

    try {
      StatusCodeHelper.dontShow404Alert = true;
      let response: any = await this.$http.post('/api/v1/toplu-not-ekle', this.notBilgileri);

      if (response.data.status) {
        // All notes were added successfully
        this.xmlObject = this.secilenler.map((kartNo: string) => ({
          kart_no: kartNo,
          messages: "Not başarıyla eklendi",
          status: false,
          color: "#0ce11d"
        }));
      } else {
        const invalidIds = response.data.gecersiz_idler || [];

        this.xmlObject = this.secilenler.map((kartNo: string) => {
          if (invalidIds.includes(kartNo)) {
            return {
              kart_no: kartNo,
              messages: "Takip bulunamadı",
              status: true,
              color: "#FFEBEE"
            };
          } else {
            return {
              kart_no: kartNo,
              messages: "Not başarıyla eklendi",
              status: false,
              color: "#0ce11d"
            };
          }
        });

        this.eksikVarMi = invalidIds.length > 0;
      }
    } catch (err) {
      console.error('Error in SecilenTakipleriTakipleriKontrolEt:', err);

      this.xmlObject = this.secilenler.map((kartNo: string) => ({
        kart_no: kartNo,
        messages: 'Takip Bulunamadı' || "Not eklenirken hata oluştu",
        status: true,
        color: "#FFEBEE"
      }));

      if (err.response?.data?.gecersiz_idler) {
        this.eksikVarMi = err.response.data.gecersiz_idler.length > 0;
      }
    } finally {
      StatusCodeHelper.dontShow404Alert = false;
      this.kontrol = false;
      this.ready = true;
    }
  }


  @Watch('icraDairesi')
  onlineManuelCheck() {
    if (this.icraDairesi) {
      this.takipNasilAcilacak = "manuel";
    } else {
      this.takipNasilAcilacak = "online";
    }
  }

}
